// src/locales/ru/courses.js
// Русские переводы курсов и материалов

export default {
  title: "Основы веб-разработки",

  courses: [
    { id: 'python', name: 'Python' },
    { id: 'javascript', name: 'JavaScript' },
    { id: 'html', name: 'HTML' },
    { id: 'css', name: 'CSS' },
    { id: 'react', name: 'React' }
  ],

  materials: {
    python: [
      {
        id: 1,
        topic: "Переменные и типы данных",
        content: "В Python существует несколько базовых типов данных: int (целые числа), float (числа с плавающей точкой), str (строки), bool (логический тип). Переменные создаются простым присваиванием: x = 10. Python — язык с динамической типизацией, тип определяется автоматически."
      },
      {
        id: 2,
        topic: "Циклы",
        content: "В Python есть два основных типа циклов: for и while. Цикл for используется для перебора элементов последовательности: for i in range(10). Цикл while выполняется пока условие истинно: while x < 100. Для досрочного выхода используется break, для перехода к следующей итерации — continue."
      },
      {
        id: 3,
        topic: "Функции",
        content: "Функции в Python определяются ключевым словом def. Синтаксис: def имя_функции(параметры): тело функции. Функция может возвращать значение через return. Аргументы могут быть позиционными, именованными, или иметь значения по умолчанию. Пример: def sum(a, b=0): return a + b"
      },
      {
        id: 4,
        topic: "Списки",
        content: "Список (list) — изменяемая упорядоченная коллекция элементов. Создание: my_list = [1, 2, 3] или my_list = list(). Основные методы: append() — добавить элемент, remove() — удалить, sort() — сортировать, len() — получить длину. Индексация с 0, поддерживаются срезы: my_list[1:3]"
      }
    ],
    javascript: [
      {
        id: 5,
        topic: "Переменные в JavaScript",
        content: "В JavaScript есть три способа объявления переменных: var (устаревший), let (изменяемая) и const (константа). Используйте const по умолчанию, let когда нужно изменить значение. JavaScript — динамически типизированный язык."
      },
      {
        id: 6,
        topic: "Функции и стрелочные функции",
        content: "Функции объявляются через function или стрелочный синтаксис (=>). Стрелочные функции короче и не имеют собственного this. Функции — объекты первого класса, могут передаваться как аргументы."
      },
      {
        id: 7,
        topic: "Массивы и методы",
        content: "Массивы в JS — это объекты. Основные методы: map() (преобразование), filter() (фильтрация), reduce() (свертка), forEach() (итерация), find() (поиск). Все методы кроме forEach возвращают новый массив."
      },
      {
        id: 8,
        topic: "Асинхронность: Promises и async/await",
        content: "Promise — объект для работы с асинхронными операциями. Имеет состояния: pending, fulfilled, rejected. async/await — синтаксический сахар над промисами. Async функция всегда возвращает Promise, await ждет выполнения."
      }
    ],
    html: [
      {
        id: 9,
        topic: "Структура HTML документа",
        content: "HTML документ состоит из DOCTYPE, тега html с head и body. В head — метаданные (title, meta, link). В body — контент страницы. Все теги должны быть закрыты (кроме самозакрывающихся)."
      },
      {
        id: 10,
        topic: "Семантические теги",
        content: "Семантические теги описывают смысл содержимого: header (шапка), nav (навигация), main (основной контент), article (статья), section (секция), aside (боковая панель), footer (подвал). Улучшают SEO и доступность."
      },
      {
        id: 11,
        topic: "Формы и input элементы",
        content: "Формы создаются тегом form. Основные input типы: text, email, password, number, date, checkbox, radio, file. Атрибуты: name (для отправки), placeholder (подсказка), required (обязательное), pattern (валидация)."
      }
    ],
    css: [
      {
        id: 12,
        topic: "Селекторы CSS",
        content: "Селекторы выбирают элементы для стилизации. Типы: элемент (div), класс (.class), id (#id), атрибут ([type='text']), псевдоклассы (:hover, :focus), псевдоэлементы (::before, ::after). Комбинаторы: потомок (пробел), ребенок (>), соседний (+)."
      },
      {
        id: 13,
        topic: "Flexbox",
        content: "Flexbox — одномерная компоновка (строка или столбец). Контейнер: display: flex, flex-direction, justify-content (главная ось), align-items (поперечная ось), gap (отступы). Элементы: flex-grow, flex-shrink, flex-basis."
      },
      {
        id: 14,
        topic: "Grid Layout",
        content: "Grid — двумерная компоновка (строки и столбцы). Контейнер: display: grid, grid-template-columns/rows (определение сетки), gap (отступы). Элементы: grid-column, grid-row (размещение), grid-area (именованные области)."
      },
      {
        id: 15,
        topic: "Адаптивный дизайн",
        content: "Media queries для разных экранов: @media (max-width: 768px). Mobile-first подход: сначала стили для мобильных, затем для больших экранов. Единицы: rem (относительно root), em (относительно родителя), vw/vh (viewport), % (процент от родителя)."
      }
    ],
    react: [
      {
        id: 16,
        topic: "Компоненты и JSX",
        content: "Компоненты — строительные блоки React. Функциональные компоненты — обычные JS функции, возвращающие JSX. JSX — синтаксис похожий на HTML, но это JavaScript. Используйте className вместо class, camelCase для атрибутов."
      },
      {
        id: 17,
        topic: "Хуки: useState и useEffect",
        content: "useState — для состояния компонента. Возвращает [значение, функцию для изменения]. useEffect — для побочных эффектов (запросы, подписки). Запускается после рендера. Массив зависимостей контролирует перезапуск."
      },
      {
        id: 18,
        topic: "Props и передача данных",
        content: "Props — свойства компонента, передаются от родителя к ребенку. Неизменяемы (immutable). Деструктуризация для удобства: ({name, age}). Children prop для вложенного контента. PropTypes для валидации типов."
      },
      {
        id: 19,
        topic: "Условный рендеринг и списки",
        content: "Условный рендеринг: тернарный оператор (condition ? <A/> : <B/>), логический оператор (condition && <Component/>). Списки: map() для преобразования массива в компоненты. Обязателен уникальный key для оптимизации."
      }
    ]
  },

  faq: [
    {
      id: 1,
      question: "Как установить Python?",
      answer: "Скачайте установщик с python.org, запустите его и обязательно отметьте галочку 'Add Python to PATH'. После установки проверьте в командной строке: python --version",
      category: "python"
    },
    {
      id: 2,
      question: "Какую IDE использовать для Python?",
      answer: "Для начинающих рекомендуется PyCharm Community (бесплатная) или VS Code с расширением Python. Также подойдут Jupyter Notebook для интерактивной работы и обучения.",
      category: "python"
    },
    {
      id: 3,
      question: "В чем разница между let и const?",
      answer: "const используется для переменных, которые не будут переназначены. let — для переменных, которые могут изменяться. const не делает объект неизменяемым, только предотвращает переназначение самой переменной.",
      category: "javascript"
    },
    {
      id: 4,
      question: "Как подключить CSS к HTML?",
      answer: "Три способа: 1) Внешний файл через <link rel='stylesheet' href='style.css'> в head. 2) Внутренние стили через тег <style> в head. 3) Инлайн стили через атрибут style на элементе. Рекомендуется внешний файл.",
      category: "css"
    },
    {
      id: 5,
      question: "Как создать React приложение?",
      answer: "Используйте команду: npx create-react-app my-app. Затем cd my-app и npm start для запуска. Или используйте Vite для более быстрой сборки: npm create vite@latest my-app -- --template react",
      category: "react"
    },
    {
      id: 6,
      question: "Что такое замыкание в JavaScript?",
      answer: "Замыкание — функция, которая запоминает переменные из внешней области видимости, даже после завершения внешней функции. Используется для создания приватных переменных и модулей.",
      category: "javascript"
    }
  ],

  initialMessage: 'Здравствуйте! Я AI-помощник образовательной платформы. Помогу с вопросами по **Python**, **JavaScript**, **HTML**, **CSS** и **React**. Задавайте любые вопросы!'
};
